import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IControls } from 'bi-interfaces';


@Component({
  selector: 'bi-render-validator-msg',
  templateUrl: './bi-render-validator-msg.component.html',
  styleUrls: ['./bi-render-validator-msg.component.scss']
})
export class biRenderValidatorMsgComponent {
  @Input() formGroup!: FormGroup;
  @Input() control!: IControls;
  constructor(private translateService: TranslateService){}
}
